import React from 'react';
import { Wrapper } from 'src/domains/players/webview/components/Account/limitsTab/LimitsTab.style';
import { PlayBreakProcedure } from 'src/domains/players/webview/components/Account/limitsTab/playBreakProcedure/PlayBreakProcedure';
import { RealityCheck } from 'src/domains/players/webview/components/Account/limitsTab/realityCheck/RealityCheck';
import { SelfExclusionProcedure } from 'src/domains/players/webview/components/Account/limitsTab/selfExclusionProcedure/SelfExclusionProcedure';
import { observer } from 'src/utils/mobx-react';
import { RollingNetDepositLimit } from 'src/domains/players/webview/components/Account/limitsTab/rollingNetDepositLimit/RollingNetDepositLimit';
import { AccountReview } from './accountReview/AccountReview';
interface PropsType {
    rollingNetDepositLimit: boolean;
}

export const LimitsTab = observer('LimitsTab', ({ rollingNetDepositLimit }: PropsType) => {
    return (
        <Wrapper>
            {rollingNetDepositLimit === true ? <RollingNetDepositLimit /> : null}
            <PlayBreakProcedure />
            <SelfExclusionProcedure />
            <RealityCheck />
            <AccountReview />
        </Wrapper>
    );
});
